import Vue from 'vue';
import { FIELD_TYPES_INDEX } from "components/project/create/SchemaUtils";
export default Vue.extend({
    name: "Schema",
    props: {
        settingIndex: { type: String, required: true },
        schema: { type: Array, default: () => [] }
    },
    data() {
        return {
            fieldTypesIndex: FIELD_TYPES_INDEX,
        };
    },
    computed: {
        uniqueFieldsMsg() {
            const emptyMsg = 'Document updates is disabled on this project';
            const uniqueGroup = this.schema.filter(col => col.unique_group === true);
            return uniqueGroup.length > 0 ? uniqueGroup : emptyMsg;
        }
    },
});
